import { Routes } from '@angular/router';
import { Settings } from 'src/app/core/pages/settings/settings';
import { DashboardLayoutComponent } from 'src/app/core/layouts/dashboard-layout/dashboard-layout';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    component: DashboardLayoutComponent,
    children: [{
      path: 'settings',
      pathMatch: 'full',
      component: Settings
    }]
  }
];
